<style lang="scss">
.orange {
  color: #f68321;
}
.fz20 {
  font-size: 20px;
}
.box {
  padding: 20px 10px;
  a {
    font-size: 12px;
    text-decoration: underline;
    color: #5078e6;
  }
  .amount-box {
    line-height: 40px;
    .summary {
      border-bottom: 1px solid #d8d9df;
      margin-bottom: 10px;
      .left {
        float: left;
        font-weight: bold;
        font-size: 16px;
      }
      .right {
        float: right;
        table {
          margin-bottom: 20px;
        }
        td {
          text-align: right;
          line-height: 20px;
        }
      }
      .el-form-item__content {
        float: left;
      }
    }
    .dikou-box {
      border-bottom: 1px solid #d8d9df;
      padding-bottom: 10px;
      .el-checkbox__label {
        font-size: 12px;
      }
      .checkbox-box {
        line-height: 24px;
        font-size: 12px;
      }
    }
    .bankpay-box {
      p {
        line-height: 60px;
      }
    }
  }
  .tips {
    font-size: 12px;
    margin-top: 50px;
  }
}
.bt15 {
  border-top: 15px #f4f4f4 solid;
  padding: 0 10px;
}

.wait-yanmi {
  text-align: center;
  img {
    width: 402px;
    height: 85px;
  }
  h4 {
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    margin: 10px;
  }
  p {
    span {
      color: orange;
    }
  }
}
.btn-box {
  text-align: center;
  .el-button--medium {
    margin: 30px 20px;
    width: 200px;
    font-family: microsoft yahei;
    font-size: 16px;
    height: 44px;
  }
  .el-button--primary.is-plain {
    background: #ffffff;
  }
  .el-button--primary.is-plain:focus,
  .el-button--primary.is-plain:hover {
    background: #409eff;
    border-color: #409eff;
    color: #fff;
  }
}
.el-button--medium {
  width: 280px;
  font-family: microsoft yahei;
  font-size: 16px;
  height: 44px;
}

.el-dialog__body {
  border-top: 1px solid #ddd;
}
.el-autocomplete {
  width: 200px !important;
}
</style>

<template>
  <div v-loading="loading">
    <gf-page-title title="一次性结清" />
    <div class="box clearfix">
      <div class="amount-box">
        <div class="summary clearfix">
          <div class="left">
            <h3>一次性结清应付总额：{{amountInfo.maxRepayAmt | currenc}}元</h3>
          </div>
          <div class="right">
            <table>
              <tr>
                <td>其中包含：本期应还：</td>
                <td class="orange">{{amountInfo.currPeriodAmt | currenc}}元</td>
              </tr>
              <tr>
                <td>剩余本金：</td>
                <td class="orange">{{amountInfo.restPrincipal | currenc}}元</td>
              </tr>
              <tr>
                <td>提前还款违约金：</td>
                <td class="orange">{{amountInfo.prepayPenalty | currenc}}元</td>
              </tr>
              <tr>
                <td>提前还款退费：</td>
                <td class="orange">{{amountInfo.prepayRefundSingleFee | currenc}}元</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="dikou-box">
          <div v-if="userInfo.yrbAmount !=0" class="checkbox-box">
            <el-checkbox
              :checked="dikou.taojinbi ==userInfo.yrbAmount "
              @change="val =>$set(dikou,'yirenbi',val?userInfo.yrbAmount:0)"
            >使用宜人币抵扣还款：{{userInfo.yrbAmount | currenc}}元</el-checkbox>
          </div>
          <div v-if="userInfo.rmbAmount !=0" class="checkbox-box">
            <el-checkbox
              :checked="dikou.yue ==userInfo.rmbAmount "
              @change="val =>$set(dikou,'yue',val?userInfo.rmbAmount:0)"
            >账户可用现金支付：{{userInfo.rmbAmount | currenc}}元</el-checkbox>
          </div>
        </div>
        <div v-if="bankPayAmount" class="bankpay-box">
          <p>
            银行卡支付：
            <span class="orange fz20">{{bankPayAmount | currenc}}</span>元
          </p>
        </div>

        <!--<el-form :inline="true" ref="amountForm" :model="amountFormData" :rules="rules">-->
        <!--<el-form-item label="充值金额：" prop="payAmount">-->
        <!--<el-input class="cus" v-model="amountFormData.payAmount"> </el-input>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="元">-->
        <!--</el-form-item>-->

        <!--</el-form>-->
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="box bt15">
      <!--银行列表模块-->
      <bank-list v-if="bankPayAmount" />

      <div class="clearfix"></div>
      <el-button
        size="medium"
        type="primary"
        @click="recharge"
        :disabled="btnLoading || visibleEditForm"
        v-loading="btnLoading"
      >立即支付</el-button>
      <p class="tips">
        <span>温馨提示</span>
        <br />1.为了您能顺利完成支付，请使用在银行办理的一类账户进行支付
        <br />2.借款用户充值的金额仅可用于还款
        <br />3.所有账户可用金额将由第三方平台存管
        <br />4.请注意您的网银支付上限
        <br />5.如充值金额没有及时到账，请您联系客服：400-811-2288
        <br />
      </p>
    </div>
    <el-dialog
      title="存管信息提示"
      :visible.sync="dialogVisible"
      width="750px"
      :close-on-click-modal="false"
      top="30vh"
    >
      <div class="wait-yanmi">
        <img src="../../assets/images/yrd_gf.jpg" alt />
        <h4 v-if="yanmiStatus==0">您是否已在广发银行页面完成交易验证？</h4>
        <h4 v-if="yanmiStatus == -1">查询到您在广发银行页面交易验证操作失败，请重试。</h4>
      </div>
      <div class="btn-box">
        <el-button
          v-if="yanmiStatus == 0"
          size="medium"
          type="primary"
          @click="checkResultHeng2();doLog('PC支付流程-是否完成验证-已完成验证')"
        >已完成验证</el-button>
        <el-button
          v-if="yanmiStatus == -1"
          size="medium"
          type="primary"
          @click="goYanmi();doLog('PC支付流程-是否完成验证-重新验证')"
        >重新验证</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="goZfwt();doLog('PC支付流程-是否完成验证-支付遇到问题')"
          plain
        >支付遇到问题</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="存管信息提示"
      :visible.sync="dialogGFVisible"
      width="600px"
      :close-on-click-modal="false"
      top="30vh"
    >
      <div class="wait-yanmi">
        <img src="../../assets/images/yrd_gf.jpg" alt />
        <h4>
          为了您的后续操作
          <br />需跳转至广发银行页面，完成存管账户后续操作
        </h4>
      </div>
      <div class="btn-box">
        <el-button size="medium" type="primary" @click="goYanmi">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="正在还款"
      :visible.sync="dialogPayingVisible"
      width="600px"
      :close-on-click-modal="false"
      top="30vh"
    >
      <div class="wait-yanmi">
        <h4>请您在新打开的网上银行页面上完成付款</h4>
        <p>付款完成前请不要关闭窗口，充值完成后请根据您的情况点击下面的按钮。</p>
      </div>
      <div class="btn-box">
        <el-button size="medium" type="primary" @click="queryPayResult">已完成支付</el-button>
        <el-button type="primary" size="medium" @click="goZfwt" plain>支付遇到问题</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import GfPageTitle from "../../components/gfPageTitle";
import bankList from "../../components/bankList";
export default {
  components: { GfPageTitle, bankList },

  data() {
    var validateInputAmount = (rule, value, callback) => {
      // if (value === '') {
      // 	callback(new Error('请输入还款金额'));
      // } else {
      // 	if (this.ruleForm.checkPass !== '') {
      // 		this.$refs.ruleForm.validateField('checkPass');
      // 	}
      // 	callback();
      // }

      if (!/^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/.test(this.payData.amount)) {
        callback(new Error("请输入正确的金额"));
      }
      if (this.payData.amount < this.amountInfo.minRepayAmt) {
        callback(
          new Error("还款金额最低" + this.amountInfo.minRepayAmt + "元")
        );
      }

      if (this.payData.amount > this.amountInfo.maxRepayAmt) {
        let message = "填写金额不可超过" + this.amountInfo.maxRepayAmt + "元";
        callback(new Error(message));
      }
      callback();
    };

    return {
      loading: false,
      orderId: "",
      payId: "",
      dialogVisible: false,
      dialogGFVisible: false,
      dialogPayingVisible: false,
      yanmiUrl: "",

      btnLoading: false,
      activeName: "first", //bl
      baseUrl: process.env.BASE_URL,
      amountFormData: { payAmount: "" },
      rules: {
        payAmount: {
          required: true,
          pattern: /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/,
          message: "请输入正确的金额",
          trigger: "blur"
        },
        inputAmount: [{ validator: validateInputAmount, trigger: "blur" }]
      },
      rechargeBankIndex: "",

      dikou: { yirenbi: 0, yue: 0 },
      amountInfo: {},
      checkList: [],
      inputAmount: 0,
      payData: {},
      visibleEditForm: false,
      yanmiStatus: 0 //0未验密； 1验密成功  ； -1验密失败
    };
  },

  computed: {
    userInfo() {
      return this.$store.state.user;
    },
    banksData() {
      return this.$store.state.payBanksData;
    },
    bankPayAmount() {
      let amount =
        this.amountInfo.maxRepayAmt - this.dikou.yirenbi - this.dikou.yue;
      return amount > 0 ? amount : 0;
    }
  },

  methods: {
    useTaojinbi() {
      this.taojinbi = this.taojinbi ? 0 : 100;
    },
    useYue() {
      this.yue = this.yue ? 0 : 100;
    },
    getAmountInfo() {
      this.loading = true;
      this.$axios({
        method: "get",
        url:
          "/borrows/" +
          this.$route.params.applyId +
          "/repayment/amountInfo?repayType=2"
      })
        .then(res => {
          console.log(res);
          this.loading = false;
          this.amountInfo = res.data;
          this.$set(this.payData, "amount", this.inputAmount);
        })
        .catch(err => {
          this.loading = false;
          console.warn(err);
        });
    },
    getAccountUrl() {
      this.btnLoading = true;

      this.$axios({
        method: "post",
        url: "/user/supervise/account",
        data: {
          returnUrl:
            window.location.protocol +
            "//" +
            window.location.host +
            "/pcloan/user/recharge"
        }
      })
        .then(res => {
          this.btnLoading = false;
          if (res.result) {
            this.$router.push({
              name: "guangfaRedirect",
              query: {
                redirect: encodeURIComponent(res.data.url),
                toCreate: "1"
              }
            });
          } else {
            this.$alert(res.message, "提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(err => {
          this.btnLoading = false;
          console.warn(err);
        });
    },
    getDepositInfo() {
      this.btnLoading = true;
      this.$axios({
        method: "get",
        url: "/user/supervise/status"
      })
        .then(res => {
          console.log(res);
          this.btnLoading = false;
          if (res.data.superviseStatus == "1") {
            //已开户
            this.amtCheck();
          } else {
            this.getAccountUrl();
            this.doLog("PC支付流程-广发开户");
          }
        })
        .catch(err => {
          this.btnLoading = false;
          console.warn(err);
        });
    },
    recharge() {
      _hmt.push(["_trackEvent", "点击事件", "账户首页-一次性结清-立即支付"]);

      this.getDepositInfo();
    },
    goZfwt() {
      window.open("https://www.yirendai.com/support/others/wyfw/", "_blank");
    },

    amtCheck() {
      if (this.bankPayAmount == 0) {
        this.btnLoading = true;
        this.quickPayRequest();
        return;
      }

      if (this.banksData.activeTabName == "kj") {
        if (!this.banksData.kjBindCardId) {
          this.$alert("请选择银行卡", "提示", {
            confirmButtonText: "确定"
          });
          return;
        }
        this.btnLoading = true;

        this.quickPayRequest();
      } else {
        if (!this.banksData.wybankid) {
          this.$alert("请选择银行卡", "提示", {
            confirmButtonText: "确定"
          });
          return;
        }
        this.btnLoading = true;

        this.bankPayRequest();
      }
    },
    quickPayRequest() {
      let totalPayAmt = this.amountInfo.maxRepayAmt;
      let toPayAmt = this.bankPayAmount;
      let applyId = this.$route.params.applyId;
      let bindCardId = this.banksData.kjBindCardId;
      let useAccountAmt = this.dikou.yue;
      let yrbPayAmt = this.dikou.yirenbi;
      // 抵扣取值
      //首选宜人币
      if (this.dikou.yirenbi > totalPayAmt) {
        yrbPayAmt = totalPayAmt;
        useAccountAmt = 0;
      } else {
        yrbPayAmt = this.dikou.yirenbi;
        let daihuan = totalPayAmt - yrbPayAmt;
        if (this.dikou.yue > daihuan) {
          useAccountAmt = daihuan;
        } else {
          useAccountAmt = this.dikou.yue;
        }
      }

      // let bindCardId =bindCard?bindCard['bindCardId']:this.banksData.kjBanks[0]['bindCardId']
      let payChannel = "REPAY";
      let payType = "5";
      this.axios({
        url: "/repay2/quickPayRequest",
        method: "post",
        data: {
          applyId,
          totalPayAmt,
          useAccountAmt,
          yrbPayAmt,
          bindCardId,
          payChannel,
          payType
        }
      })
        .then(res => {
          console.log(res);
          this.btnLoading = false;

          if (res.result) {
            this.payId = res.data.payId;
            // 判断一次性结清总金额为零则跳过广发存管验密流程后面流程没改,没有还款进度的话可以直接展示还款结果页
            if (totalPayAmt == 0) {
              // this.$router.push({name:'payStatus', query: { state:'02' }})
              // this.$router.push({name:'payAllHeng2Submit',params:{payId:this.payId}})
              if (this.banksData.activeTabName == "kj") {
                if (this.bankPayAmount == 0) {
                  this.QuickSmsOnPay0();
                  return;
                }
                //到快捷支付提交页面
                let rechargeBindCardId = this.banksData.kjBindCardId;
                let bank = this.banksData.kjBanks.find(b => {
                  return b.bindCardId == rechargeBindCardId;
                });
                let bankEnName = bank["bankEnShortName"];
                let bankAccountNo = bank["bankCardNo"];
                let payAmount = this.bankPayAmount;
                const data = {
                  payAmount,
                  bankEnName,
                  bankAccountNo,
                  rechargeBindCardId
                };
                window.localStorage.setItem(this.payId, JSON.stringify(data));

                this.$router.push({
                  name: "payAllHeng2Submit",
                  params: { payId: this.payId }
                });
              } else {
                //网银支付
                this.getBankPayUrl();
              }
            } else {
              this.checkUrl(this.payId);
            }
          } else {
            this.$alert(res.message, "提示", {
              confirmButtonText: "确定"
            });
            this.btnLoading = false;
            this.doLog("PC支付流程-" + res.message);
          }
        })
        .catch(err => {
          alert("系统错误,请稍后再试");
          this.btnLoading = false;

          console.warn(err);
        });
    },
    bankPayRequest() {
      let totalPayAmt = this.amountInfo.maxRepayAmt;
      let applyId = this.$route.params.applyId;
      let toPayAmt = this.bankPayAmount;
      let bankId = this.banksData.wybankid;
      let payChannel = "REPAY";
      let payType = "5";
      let callbackUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        "/pcloan/payStatus";

      let useAccountAmt = this.dikou.yue;
      let yrbPayAmt = this.dikou.yirenbi;
      // 抵扣取值
      //首选宜人币
      if (this.dikou.yirenbi > totalPayAmt) {
        yrbPayAmt = totalPayAmt;
        useAccountAmt = 0;
      } else {
        yrbPayAmt = this.dikou.yirenbi;
        let daihuan = totalPayAmt - yrbPayAmt;
        if (this.dikou.yue > daihuan) {
          useAccountAmt = daihuan;
        } else {
          useAccountAmt = this.dikou.yue;
        }
      }
      this.axios({
        url: "/repay2/bankPayRequest",
        method: "post",
        data: {
          totalPayAmt,
          useAccountAmt,
          yrbPayAmt,
          bankId,
          payChannel,
          payType,
          applyId,
          callbackUrl
        }
      })
        .then(res => {
          console.log(res);
          this.btnLoading = false;

          if (res.result) {
            this.payId = res.data.payId;
            // 判断一次性结清总金额为零则跳过广发存管验密流程后面流程没有改,没有还款进度的话可以直接展示还款结果页
            if (totalPayAmt == 0) {
              // this.$router.push({name:'payStatus', query: { state:'02' }})
              // this.$router.push({name:'payAllHeng2Submit',params:{payId:this.payId}})
              if (this.banksData.activeTabName == "kj") {
                if (this.bankPayAmount == 0) {
                  this.QuickSmsOnPay0();
                  return;
                }
                //到快捷支付提交页面
                let rechargeBindCardId = this.banksData.kjBindCardId;
                let bank = this.banksData.kjBanks.find(b => {
                  return b.bindCardId == rechargeBindCardId;
                });
                let bankEnName = bank["bankEnShortName"];
                let bankAccountNo = bank["bankCardNo"];
                let payAmount = this.bankPayAmount;
                const data = {
                  payAmount,
                  bankEnName,
                  bankAccountNo,
                  rechargeBindCardId
                };
                window.localStorage.setItem(this.payId, JSON.stringify(data));

                this.$router.push({
                  name: "payAllHeng2Submit",
                  params: { payId: this.payId }
                });
              } else {
                //网银支付
                this.getBankPayUrl();
              }
            } else {
              this.checkUrl(this.payId);
            }
          } else {
            this.$alert(res.message, "提示", {
              confirmButtonText: "确定"
            });
            this.btnLoading = false;
          }
        })
        .catch(err => {
          alert("系统错误,请稍后再试");
          this.btnLoading = false;

          console.warn(err);
        });
    },

    checkUrl(payId) {
      this.$axios({
        method: "post",
        url: "/user/supervise/password/HuiMinCheckUrl",
        data: {
          payId,
          returnUrl:
            window.location.protocol +
            "//" +
            window.location.host +
            "/pcloan/testDensity"
        }
      })
        .then(res => {
          console.log(res);
          this.btnLoading = false;

          if (res.result) {
            this.yanmiUrl = res.data.url;
            this.dialogGFVisible = true;
            this.bizId = res.data.bizId;
            this.doLog("PC支付流程-跳转广发弹窗");
          } else {
            this.$alert(res.message, "提示", {
              confirmButtonText: "确定"
            });
            this.btnLoading = false;
          }
        })
        .catch(function(err) {
          console.warn(err);
          this.btnLoading = false;
        });
    },
    goYanmi() {
      window.open(this.yanmiUrl, "_blank");
      this.dialogVisible = true;
      this.yanmiStatus = 0;
    },

    QuickSmsOnPay0() {
      this.$axios({
        method: "post",
        url: "/repay2/quickPaySms",
        data: { payId: this.payId }
      })
        .then(res => {
          console.log(res);
          if (res.result) {
            if (res.data.status == "PAID") {
              this.queryPayResult();
            } else {
              this.$alert("支付失败：" + res.data.errorCode, "提示", {
                confirmButtonText: "确定"
              });
            }
          } else {
            this.$alert(res.berrormsg, "提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(err => {
          console.warn(err);
        });
    },
    checkResultHeng2() {
      this.$axios({
        method: "get",
        url: "/user/supervise/password/checkHuiMinResult?bizId=" + this.bizId
      })
        .then(res => {
          console.log("验密结果", res);

          if (res.result) {
            this.yanmiStatus = 1;
            if (this.banksData.activeTabName == "kj") {
              if (this.bankPayAmount == 0) {
                this.QuickSmsOnPay0();
                return;
              }
              //到快捷支付提交页面
              let rechargeBindCardId = this.banksData.kjBindCardId;
              let bank = this.banksData.kjBanks.find(b => {
                return b.bindCardId == rechargeBindCardId;
              });
              let bankEnName = bank["bankEnShortName"];
              let bankAccountNo = bank["bankCardNo"];
              let payAmount = this.bankPayAmount;
              const data = {
                payAmount,
                bankEnName,
                bankAccountNo,
                rechargeBindCardId
              };
              window.localStorage.setItem(this.payId, JSON.stringify(data));

              this.$router.push({
                name: "payAllHeng2Submit",
                params: { payId: this.payId }
              });
            } else {
              //网银支付
              this.getBankPayUrl();
            }
          } else {
            this.yanmiStatus = -1;

            this.$alert(res.message, "提示", {
              confirmButtonText: "确定"
            });
            this.doLog("PC支付流程-验密失败-支付遇到问题");
          }
        })
        .catch(err => {
          console.warn(err);
          this.yanmiStatus = -1;
        });
    },
    getBankPayUrl() {
      this.$axios({
        method: "post",
        url: "/repay2/getBankPayUrl",
        data: { payId: this.payId }
      })
        .then(res => {
          console.log(res);
          this.btnLoading = false;

          if (res.result) {
            //去往网银支付，打开新页面
            this.dialogGFVisible = false;
            this.dialogPayingVisible = true;
            window.open(res.data.payUrl, "_blank");
          } else {
            this.$alert(res.message, "提示", {
              confirmButtonText: "确定"
            });
            this.btnLoading = false;
          }
        })
        .catch(function(err) {
          console.warn(err);
          this.btnLoading = false;
        });
    },

    querySearch(queryString, cb) {
      var data = [
        { desc: "当前应还总额：", amount: this.amountInfo.maxRepayAmt + "" },
        { desc: "逾期部分：", amount: this.amountInfo.overdueAmt + "" }
      ];
      // 调用 callback 返回建议列表的数据
      var results;
      if (queryString) {
        results = queryString.length >= 2 ? [] : data;
      } else {
        results = data;
      }
      cb(results);
    },
    handleSelect(item) {
      console.log(item);
      this.payData.amount = item.amount;
    },
    confirmAmount() {
      this.$refs["editAmoutForm"].validate().then(() => {
        this.visibleEditForm = false;
        this.inputAmount = this.payData.amount;
      });
    },
    queryPayResult() {
      let payId = this.payId;
      console.log("payId", payId);
      this.$axios({
        method: "post",
        url: "/repay2/queryPayResult",
        data: { payId }
      })
        .then(res => {
          console.log(res);

          if (res.result) {
            if (res.data.status == "DEALING" || res.data.status == "UNPAY") {
              this.queryPayResult();
            }
            if (res.data.status == "OK") {
              this.$router.push({ name: "payStatus", query: { state: "02" } });
              _hmt.push([
                "_trackEvent",
                "还款成功事件",
                "账户首页-一次性结清-还款成功"
              ]);
            }
            if (res.data.status == " FAIL") {
              this.$router.push({ name: "payStatus", query: { state: "03" } });
            }
          } else {
            this.$alert(res.message, "提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(function(err) {
          console.warn(err);
        });
    }
  },
  created() {
    this.getAmountInfo();
  }
};
</script>
